import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  deleting: boolean
  onDelete: () => void
  onClose: () => void
}

const DeleteModal = ({ onClose, onDelete, deleting }: Props) => {
  const deleteElement = async () => {
    await onDelete()
    onClose()
  }

  return (
    <Modal
      illustration="delete"
      onClose={onClose}
      title={i18n.t('bookkeepers.incidence.task_document.remove_task_document.heading')}
      description={i18n.t('bookkeepers.incidence.task_document.remove_task_document.information')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('bookkeepers.incidence.task_document.remove_task_document.button.cancel')}
          </Button>
          <Button type="primary" disabled={deleting} onClick={deleteElement}>
            {i18n.t('bookkeepers.incidence.task_document.remove_task_document.button.delete')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteModal
